import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Field, reduxForm} from 'redux-form'
import {Badge, Col, Form, Modal, Row} from "react-bootstrap"
import {CheckboxField, DateField, RadioField, SelectField, TextareaField, TextField} from '../form/form'
import {connect} from "react-redux";
import {showMessage} from '../../actions';
import {defaultState} from '../../reducers/entity';
import {
	AllergyStatus,
	AllergyStatusLabel,
	AnimalKind,
	BaseStatus,
	captureOptions,
	DEFAULT_CONTRACT_LOCATION,
	DogVariant,
	IntakePartyLabel,
	IntakeType,
	IntakeTypeLabel,
	PartyVariant,
	yesNoOptions
} from "../../utils/enums";
import {addNestedError, createOptions, Date, Enums, resolveApiResult, validateChipNumber} from "../../utils";
import {showModal} from "../../actions/modal";
import {loadIntake, saveIntake} from "../../actions/intakes";
import {handleItemSave, ItemContext, onItemSaveSuccess, renderItemFormButtons, renderItemFormFiles} from "../dog/helpers";
import {loadFiles, saveFile} from "../../actions/files";
import PartyField from "../form/PartyField";
import {renderDateField} from "../form/DateField";
import DogField from "../form/DogField";
import DogFields, {DogFieldsType} from "../dog/DogFields";
import ExamFields from "../dog/ExamFields";

const validate = (values) => {
	const errors = {};
	if (!values.intakeType) {
		errors.intakeType = 'Zvolte prosím typ příjmu';
	} else {
		let hasExam = false;
		let hasContract = false;
		let hasParty = false;

		switch (values.intakeType) {
			case IntakeType.F:
				if (!values.municipalityId) {
					errors.municipalityId = 'Vyberte prosím';
				}
				if (!values.findAt) {
					errors.findAt = 'Zadejte prosím datum a čas nálezu'
				}
				if (!values.muniIsReported && values.muniIsReported !== false) {
					errors.muniIsReported = 'Vyberte prosím'
				}
				hasExam = true;
				break;

			case IntakeType.R:
				hasParty = true;
				hasExam = true;
				hasContract = true;
				break;

			case IntakeType.P:
			case IntakeType.H:
				hasParty = true;
				hasContract = true;
				break;

			case IntakeType.M:
				if (!values.municipalityId) {
					errors.municipalityId = 'Vyberte prosím';
				}
				hasExam = true;
				break;

			case IntakeType.I:
			case IntakeType.A:
				hasParty = true;
				break;

			case IntakeType.B:
				hasExam = true;
				break;

			default:
		}

		if (hasParty) {
			if (!values.partyId) {
				errors.partyId = 'Vyberte prosím';
			}
		}

		if (hasExam) {
			if (!values.exam || !values.exam.examBy) {
				addNestedError(errors, 'exam', 'examBy', 'Vyberte prosím pracovníka');
			}
			if (!values.exam || !values.exam.examDate) {
				addNestedError(errors, 'exam', 'examDate', 'Zadejte prosím datum');
			}
			if (!values.exam || !values.exam.examResult) {
				addNestedError(errors, 'exam', 'examResult', 'Zadejte prosím stav');
			}
		}

		if (hasContract) {
			if (!values.contractDate) {
				errors.contractDate = 'Zadejte prosím datum smlouvy'
			}
		}
	}

	if (!values.dog || !values.dog.name) {
		addNestedError(errors, 'dog', 'name', 'Zadejte prosím jméno (známé nebo dočasné)');
	}

	if (!values.dogNumber && values.intakeType !== IntakeType.H) {
		errors.dogNumber = 'Povinné';
	}

	validateChipNumber(values, 'chipNumber', errors, false, true);

	return errors
}

const textual = (item) => {
	return IntakeTypeLabel[item.intakeType] + ' ' + Date.formatDate(item.intakeAt) + ' (ID ' + item.intakeId + ')';
}

const muniTitles = [
	'Policie',
	'Exekutor',
	'Krajská veterinární správa',
	'Soud',
	'ÚZSVM'
]

export const createIntakeInitialValues = (intakeId, dogId, session, dog = null, cloneIntake: null) => {
	if (intakeId && !cloneIntake) {
		return {dogId, intakeId};
	}

	const intake = Object.assign(
		cloneIntake ? {...cloneIntake, intakeId: null} : {},
		{
			dogId,
			intakeAt: Date.format(Date.today(), Date.ISO_DATE_TIME),
			contractLocation: DEFAULT_CONTRACT_LOCATION,
			contractDate: Date.format(Date.today(), Date.ISO_DATE),
			exam: {
				examDate: Date.format(Date.today(), Date.ISO_DATE)
			},
			dog: {
				dogId,
				animalKind: AnimalKind.DOG
			},
			intakeBy: session.user.userId
		});

	if (dog) {
		['chipNumber', 'isTat', 'tatNumber', 'tatDesc', 'castrationStatus', 'castrationDate'].forEach((n) => {
			intake[n] = dog[n];
		})
	}

	return intake;
}

class IntakeForm extends Component {

	ctx: ItemContext;

	constructor(props) {
		super(props);

		this.state = {
			intakeType: null,
			intakeAt: null,
			currentFiles: [],
			muniIsReported: null,
			heriIsFinal: null,
			hotelFrom: null,
			hotelTo: null,
			allergyStatus: null
		}

		this.handleSave = this.handleSave.bind(this);

		this.ctx = {
			itemTag: 'Příjem',
			itemKeyName: 'intakeId',
			saveItem: props.saveIntake,
			saveFile: props.saveFile,
			showMessage: props.showMessage,
			textual,
			onSuccess: (item) => onItemSaveSuccess(item, props)
		}
	}

	componentWillMount() {
		this.loadIntake(this.props);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.intake.intakeId !== this.props.intake.intakeId) {
			this.loadIntake(nextProps);
		}
	}

	loadIntake(props) {
		const {intake} = props;
		if (intake.intakeId) {
			this.props.loadIntake(intake.intakeId).then((json) => {
				if (resolveApiResult(json)) {
					this.syncEnumsAndState(json.response.data);
				}
			});
			this.props.loadFiles({intakeId: intake.intakeId, statuses: [BaseStatus.ACTIVE]}).then((json) => {
				if (resolveApiResult(json)) {
					this.setState({currentFiles: json.response.data});
				}
			});
		} else {
			this.syncEnumsAndState(intake);
		}
	}

	syncEnumsAndState(intake) {
		this.setState({
			intakeType: intake == null ? null : intake.intakeType,
			intakeAt: intake == null ? null : intake.intakeAt,
			muniIsReported: intake == null ? null : intake.muniIsReported,
			heriIsFinal: intake == null ? null : intake.heriIsFinal,
			hotelFrom: intake == null ? null : intake.hotelFrom,
			hotelTo: intake == null ? null : intake.hotelTo,
			allergyStatus: intake == null ? null : intake.allergyStatus,
		});
	}

	handleSave(values) {
		const v = {...values};
		switch (values.intakeType) {
			case IntakeType.P:
			case IntakeType.R:
			case IntakeType.H:
				break;

			default:
				v.contractLocation = null;
				v.contractDate = null;
				break;
		}
		return handleItemSave(this.ctx, v);
	}

	render() {
		const {entity: {item, isFetchingItem}, modal} = this.props;

		return <Modal onHide={modal.onHide} show={true} backdrop={'static'} keyboard={false}>
			{(!item || isFetchingItem) ? null : this.renderForm()}
		</Modal>
	}

	getPartyField(intakeType) {
		return <Field key={'partyId'} label={IntakePartyLabel[intakeType]} name="partyId" variant={PartyVariant.INTAKE_PARTY} component={PartyField} clearable={true}/>;
	}

	getAnimalRows(intakeType) {
		const {allergyStatus} = this.state;
		const rows = [];

		if (!this.props.initialValues.dogId) {
			rows.push(<Row key={'dogHeader'}><h5 className="divider">Zvíře - obecné</h5></Row>)
			rows.push(<DogFields key={'dogFieldsGeneral'} {...this.props} type={DogFieldsType.GENERAL} parent={'dog'}/>)
		}

		let behaviorTitle = 'Uvedené chování';
		let isCastration = true;
		let isChipAndTattoo = true;

		switch (intakeType) {
			case IntakeType.F:
				behaviorTitle = 'Projevy chování'
				break;

			case IntakeType.R:
				behaviorTitle = null;
				isCastration = false;
				break;

			case IntakeType.B:
				behaviorTitle = null;
				isCastration = false;
				isChipAndTattoo = false;
				break;

			case IntakeType.A:
				isCastration = false;
				break;

			default:
				break;
		}

		rows.push([
			<Row key={'dogNameAndNumber'}>
				<h5 className="divider">Zvíře - stav platný k okamžiku příjmu</h5>
				{intakeType !== IntakeType.B && <Col sm={6}>
					<Field label={'Jméno'} name={"dogName"} placeholder={'Jejich'} component={TextField} maxLength={100} sizes={[4, 8]}/>
				</Col>}
				{intakeType !== IntakeType.H && <Col sm={6}>
					<Field label={'Ev. č.'} name={"dogNumber"} component={TextField} maxLength={20} sizes={[4, 8]}/>
				</Col>}
			</Row>,
			isChipAndTattoo && <Row key={'chipNumber'}>
				<Col sm={12}>
					<Field label={'Čip'} name={"chipNumber"} placeholder={'Více čísel oddělte čárkou'} component={TextField} maxLength={100} sizes={[2, 10]}/>
				</Col>
			</Row>,
			<DogFields key={'dogFieldsSnapshot'} {...this.props}
				fields={{behaviorTitle, isCastration, isChipAndTattoo}}
				type={DogFieldsType.SNAPSHOT} parent={null}/>
		]);

		if (intakeType === IntakeType.H) {
			rows.push([
				<Row key={'healthDesc'}>
					<h5 className="divider">Zdravotní problémy</h5>
					<Col sm={12}>
						<Field label={'Popis'} name={"healthDesc"} type="text" component={TextareaField}/>
					</Col>
				</Row>,
				<Row key={'healthDir'}>
					<Col sm={12}>
						<Field label={'Pokyny k ošetřování'} name={"healthDir"} type="text" component={TextareaField}/>
					</Col>
				</Row>,
				<Row key={'healthMedicine'}>
					<Col sm={12}>
						<Field label={'Pokyny k pod. léků'} name={"healthMedicine"} type="text" component={TextareaField}/>
					</Col>
				</Row>,
				<Row key={'allergyStatus'}>
					<Col sm={6}>
						<Field label={'Potravinová alergie'} name={"allergyStatus"} component={RadioField} options={createOptions(AllergyStatusLabel)}
							onChangeHook={(allergyStatus) => this.setState({allergyStatus})}/>
					</Col>
				</Row>,
				allergyStatus === AllergyStatus.YES && <Row key={'allergyDesc'}>
					<Col sm={12}>
						<Field label={'Poznámka k alergii'} name={"allergyDesc"} type="text" component={TextareaField}/>
					</Col>
				</Row>
			]);
		}

		return rows;
	}

	renderForm() {
		const {entity: {item}, initialValues, handleSubmit, enums} = this.props;
		const {intakeType, muniIsReported, heriIsFinal, hotelFrom, hotelTo} = this.state;

		const rows = [];
		let hasExam = false;
		let hasContract = false;
		let hasOrigContract = false;
		let hasHeritage = false;
		let hasHotel = false;

		switch (intakeType) {
			case IntakeType.F: // find
				hasExam = true;
				rows.push([
					<Row key={'findLocation'}>
						<h5 className="divider">Nález</h5>
						<Col sm={6}>
							<Field label={'Místo'} title={'Místo nálezu'} name={"findLocation"} component={TextField} maxLength={100}/>
						</Col>
						<Col sm={6}>
							{renderDateField({
								label: 'Datum a čas', title: 'Datum a čas nálezu', name: 'findAt', maxDate: Date.today(),
								clearable: true, withTime: true
							})}
						</Col>
					</Row>,
					<Field key={'muni'} label={'Obec'} name="municipalityId" variant={PartyVariant.INTAKE_MUNI} component={PartyField} clearable={true}/>,
					<Row key={'muniReport'}>
						<Col sm={6}>
							<Field label={'Nahlášeno'} title={'Nahlášení nálezu obci'} name={"muniIsReported"} component={RadioField}
								options={yesNoOptions} sizes={[4, 5]} onChangeHook={(v) => this.setState({muniIsReported: v})}/>
						</Col>
						{muniIsReported && <Col sm={6}>
							<Field label={'Způsob'} name={"muniReport"} component={TextField} maxLength={100}/>
						</Col>}
					</Row>,
					this.getPartyField(intakeType),
					<Row key={'captureTypes'}>
						<h5 className="divider">Odchyt</h5>
						<Col sm={12}>
							<Field label={'Způsob'} title={'Způsob provedení odchytu'} name={"captureTypes"} component={SelectField} sizes={[2, 10]}
								options={captureOptions} multi={true}/>
						</Col>
					</Row>,
					<Row key={'captureUsers'}>
						<Col sm={12}>
							<Field label={'Provedl'} title={'Pracovník, který odchyt provedl'} name={"captureUsers"} component={SelectField} sizes={[2, 10]}
								options={Enums.createEnumItems(enums, 'user')} multi={true}/>
						</Col>
					</Row>,
					<Row key={'captureNote'}>
						<Col sm={12}>
							<Field label={'Poznámka'} title={'Poznámka k odchytu'} name={"captureNote"} type="text" component={TextareaField}/>
						</Col>
					</Row>,
				]);
				break;

			case IntakeType.P: // place
				rows.push(this.getPartyField(intakeType));
				hasContract = true;
				break;

			case IntakeType.R: // return
				rows.push(this.getPartyField(intakeType));
				rows.push(
					<Row key={'returnReason'}>
						<Col sm={12}>
							<Field label={'Důvod vrácení'} name={"returnReason"} type="text" component={TextareaField}/>
						</Col>
					</Row>);
				hasExam = true;
				hasContract = true;
				hasOrigContract = true;
				break;

			case IntakeType.M: // municipality
				rows.push([
					<Field key={'muni'} label={'Obec'} name="municipalityId" variant={PartyVariant.INTAKE_MUNI} component={PartyField} clearable={true}/>,
					<Row key={'muniTitle'}>
						<Col sm={12}>
							<Field label={'OVM'} name="muniTitle" component={TextField} maxLength={100} quickValues={muniTitles} sizes={[2, 10]}/>
						</Col>
					</Row>,
				]);
				hasExam = true;
				break;

			case IntakeType.B: // birth
				rows.push(<Field label={'Matka'} name="motherId" variant={DogVariant.MOTHER} component={DogField} clearable={true}/>);
				hasExam = true;
				break;

			case IntakeType.A: // missed hotel pickup
				rows.push(this.getPartyField(intakeType));
				break;

			case IntakeType.I: // inheritance
				rows.push(this.getPartyField(intakeType));
				hasHeritage = true;
				break;

			case IntakeType.H: // hotel
				rows.push(this.getPartyField(intakeType));
				rows.push(<Row key={'hotelFrom'}>
					<Col sm={6}>
						{renderDateField({
							label: 'Ubytování od', name: "hotelFrom", maxDate: hotelTo, clearable: true, onChangeHook: (hotelFrom) => {
								this.setState({hotelFrom})
							}
						})}
					</Col>
					<Col sm={6}>
						{renderDateField({
							label: 'Ubytování do', name: "hotelTo", minDate: hotelFrom, clearable: true, onChangeHook: (hotelTo) => {
								this.setState({hotelTo})
							}
						})}
					</Col>
				</Row>);
				hasHotel = true;
				hasContract = true;
				break;

			default:
				break;
		}

		rows.push(this.getAnimalRows(intakeType));

		if (hasHotel) {
			rows.push(<Row key={'hotelHeader'}><h5 className="divider">Pokyny zákazníka</h5></Row>);
			rows.push([
				<Row key={'isOwnFood'}>
					<Col sm={6}>
						<Field label={'Vlastní strava'} name={"isOwnFood"} component={RadioField} options={yesNoOptions}/>
					</Col>
				</Row>,
				<Row key={'foodDir'}>
					<Col sm={12}>
						<Field label={'Instrukce ke krmení'} name={"foodDir"} type="text" component={TextareaField}/>
					</Col>
				</Row>,
				<Row key={'equipmentDesc'}>
					<Col sm={12}>
						<Field label={'Výbava psa'} name={"equipmentDesc"} type="text" component={TextareaField}/>
					</Col>
				</Row>,
				<Row key={'vetExpLimit'}>
					<Col sm={6}>
						<Field label={'Max. vet. náklady'} title={'Výše maximálních nezbytných veterinárních nákladů bez nutnosti kontaktovat zákazníka'}
							name={"vetExpLimit"} component={TextField} maxLength={100}/>
					</Col>
				</Row>,
				<Field key={'altPartyId'} label={'Pověřená osoba'} name={'altPartyId'} variant={PartyVariant.ALT_PARTY} component={PartyField} clearable={true}/>
			]);
		}

		if (hasExam) {
			rows.push(<Row key={'examHeader'}><h5 className="divider">Zhodnocení zdravotního stavu</h5></Row>)
			rows.push(<ExamFields key={'examFields'} {...this.props} parent={'exam'}/>)
		}

		if (hasContract) {
			rows.push(<Row key={'contractHeader'}><h5 className="divider">Smlouva</h5></Row>);

			if (hasOrigContract) {
				rows.push(<Row key={'origContract'}>
					<Col sm={8} smOffset={4}>
						<Field label={'Původní sml. ze dne'} name={"origContractDate"} type="text" component={DateField} maxLength="12"
							sizes={[6, 6]}
							maxDate={Date.today()}/>
					</Col>
				</Row>);
			}
			if (intakeType === IntakeType.H) {
				rows.push(<Row key={'isGdprPhoto'}>
					<Col sm={10} smOffset={2}>
						<Field label={'Souhlas s použitím fotografií zvířete'} name={"isGdprPhoto"} component={CheckboxField}/>
					</Col>
				</Row>);
			}

			rows.push(<Row key={'contract'}>
				<Col sm={6}>
					<Field label={'Místo'} name={"contractLocation"} component={TextField} maxLength={100}/>
				</Col>
				<Col sm={6}>
					<Field label={'Datum sml.'} name={"contractDate"} type="text" component={DateField} maxLength="12"
						maxDate={Date.today()}/>
				</Col>
			</Row>);
		}

		if (hasHeritage) {
			rows.push(<Row key={'heriHeader'}><h5 className="divider">Údaje k řízení</h5></Row>);
			rows.push(<Row key={'heriIsDeclined'}>
				<Col sm={6}>
					<Field label={'Odmítnutí dědictví út.'} name={"heriIsDeclined"} component={RadioField} options={yesNoOptions} sizes={[7, 5]}/>
				</Col>
			</Row>);
			rows.push(<Row key={'heriIsFinal'}>
				<Col sm={6}>
					<Field label={'Nabytí právní moci'} name={"heriIsFinal"} component={RadioField} options={yesNoOptions} sizes={[7, 5]}
						onChangeHook={(heriIsFinal) => this.setState({heriIsFinal})}/>
				</Col>
				{heriIsFinal && <Col sm={6}>
					<Field label={'Datum nabytí'} name={"heriFinalDate"} type="text" component={DateField} maxLength="12"
						maxDate={Date.today()}/>
				</Col>}
			</Row>);
		}

		rows.push(<Row key={'intakeBy'}>
			<h5 className={'divider'}>Příjem</h5>
			<Col sm={6}>
				<Field label={'Převzal'} title={'Přebírající osoba'} name={"intakeBy"} component={SelectField} options={Enums.createEnumItems(enums, 'user')}/>
			</Col>
			<Col sm={6}>
				{renderDateField({
					label: 'Datum a čas', title: 'Datum a čas přijetí zvířete do útulku', name: "intakeAt", maxDate: Date.today(),
					clearable: true, withTime: true, onChangeHook: (intakeAt) => {
						this.setState({intakeAt})
					}
				})}
			</Col>
		</Row>);

		let title;
		if (initialValues.dog && initialValues.dog.dogId) {
			if (initialValues.intakeId) {
				title = <span>Úprava příjmu <Badge pullRight>{initialValues.intakeId}</Badge></span>;
			} else {
				title = 'Nový příjem';
			}
			if (initialValues.dog.name) {
				title = <span>{initialValues.dog.name} - {title}</span>;
			}
		} else {
			title = 'Příjem nového zvířete';
		}

		return (<Form horizontal onSubmit={handleSubmit(this.handleSave)} className="detail">
			<Modal.Header>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row>
					<Col sm={6}>
						<Field label={'Typ'} name={"intakeType"} component={SelectField} options={createOptions(IntakeTypeLabel)}
							onChangeHook={(intakeType) => this.setState({intakeType})}
						/>
					</Col>
				</Row>
				{intakeType && rows}
				{intakeType && renderItemFormFiles(this.state.currentFiles)}
			</Modal.Body>

			<Modal.Footer>
				{renderItemFormButtons(this.ctx, item, this.props)}
			</Modal.Footer>
		</Form>);
	}
}

IntakeForm = reduxForm({
	enableReinitialize: true,
	form: 'intake',
	validate
})(IntakeForm);

const mapStateToProps = (state, ownProps) => {
	const {
		entities: {intakes, dogs},
		enums,
		session
	} = state;

	const form = state.form['intake'];
	const {intake} = ownProps;

	const dog = ((dogs[intake.dogId] ? dogs[intake.dogId].item : intake.dog) || intake.dog) || {};

	const entity = intake.intakeId && intakes[intake.intakeId]
		? intakes[intake.intakeId]
		: {
			...defaultState,
			item: (form || {}).initial || (intake.intakeId ? null : {...intake, dog: {dogId: intake.dogId, ...dog}})
		};

	return {
		entity,
		initialValues: entity.item,
		dog: dog,
		enums,
		session
	}
}

IntakeForm.propTypes = {
	dog: PropTypes.object,
	intake: PropTypes.object.isRequired,
	loadIntake: PropTypes.func.isRequired,
	loadFiles: PropTypes.func.isRequired,
	saveIntake: PropTypes.func.isRequired,
	saveFile: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	modal: PropTypes.object,
	enums: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
	loadIntake,
	loadFiles,
	saveIntake,
	saveFile,
	showMessage,
	showModal
})(IntakeForm)



// WEBPACK FOOTER //
// ./src/components/intake/IntakeForm.js